import { Grid2 as Grid, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik, useFormikContext } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { User } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikDatePicker, FormikSelect, FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"


function ResetScadenzaOnRuoloChange() {
  const { values, setFieldValue } = useFormikContext<User>()
  // Reset scadenza if ruolo is not "consultazione"
  if (values.ruolo !== "consultazione" && values.scadenza) {
    setFieldValue("scadenza", undefined)
  }
  return null
}


export default function UtenteForm({ item, save, ref }: FormInDialogProps<User>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        full_name: "",
        email: "",
        ruolo: "consultazione",
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        full_name: yup.string().required().label(t("user.nome")),
        ruolo: yup.string().required().label(t("user.ruolo")),
        email: yup.string().email().required().label(t("user.email")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as User).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="full_name"
                  label={t("user.full_name")}
                  autoFocus
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  type="email"
                  name="email"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  required
                  label={t("user.email")}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikSelect}
                  name="ruolo"
                  label={t("user.ruolo")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                >
                  <MenuItem value="amministratore">{t("user.enum_ruolo.amministratore")}</MenuItem>
                  <MenuItem value="consultazione">{t("user.enum_ruolo.consultazione")}</MenuItem>
                  <MenuItem value="operatore">{t("user.enum_ruolo.operatore")}</MenuItem>
                </Field>
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikDatePicker}
                  name="scadenza"
                  label={t("user.scadenza")}
                  margin="dense"
                  type="date"
                  fullWidth
                  variant="outlined"
                  disabled={values.ruolo !== "consultazione"}
                />
              </Grid>
            </Grid>
            <ResetScadenzaOnRuoloChange />

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
